import { OrgConfigResponse } from '../apiInterfaces';
import { dashboardApi } from '../dashboard-api';

export const settingsApi = dashboardApi.injectEndpoints({
  endpoints: builder => ({
    getOrgConfig: builder.query<OrgConfigResponse, void>({
      // Feature-flag gates across the app read from this cache entry;
      // invalidating 'OrgConfig' is how a server-reported flag change
      // (e.g. a 403 feature_disabled) propagates without a reload.
      providesTags: ['OrgConfig'],
      query: () => `${API_URL}org-config`,
    }),
  }),
});

export const { useGetOrgConfigQuery } = settingsApi;
